import config from '../config'
import { get, post } from './ApiService'

export interface CommitmentFailure {
  _id: string
  weeklyCommitment: string
  status: 'pending_analysis' | 'analyzed' | 'action_open' | 'monitoring'
  result: 'not_kept' | 'withdrawn'
  explanation?: string
  rootCause?: string
  primaryCause?: string
  causeSnapshot?: {
    id?: string
    code?: string
    name?: string
    type?: string
  }
}

export interface ProjectCncCatalogRow {
  _id: string
  enabled: boolean
  cnc: {
    _id: string
    code: string
    name: string
    type: string
  }
}

const unwrap = (response: any): any => {
  if (response.error) throw new Error(response.error)
  return response.data?.data || response.data || {}
}

export const loadCommitmentFailures = async (projectId: string): Promise<CommitmentFailure[]> => {
  const response = await get(
    `${config.apiHost}/commitment-failures?project_id=${encodeURIComponent(projectId)}`,
    'COMMITMENT_FAILURES_LOAD',
  )
  const payload = unwrap(response)
  return Array.isArray(payload) ? payload : []
}

export const loadProjectCncCatalog = async (projectId: string): Promise<ProjectCncCatalogRow[]> => {
  const response = await get(
    `${config.apiHost}/project-cnc/${projectId}`,
    'PROJECT_CNC_LOAD_FOR_FAILURE',
  )
  if (response.error) throw new Error(response.error)
  return response.data?.result || []
}

export const analyzeCommitmentFailure = async (
  failureId: string,
  input: { primaryCauseId: string, explanation: string, rootCause: string },
): Promise<CommitmentFailure> => unwrap(await post(
  `${config.apiHost}/commitment-failures/${failureId}/analyze`,
  { ...input, actionRequired: true },
  'COMMITMENT_FAILURE_ANALYZE',
))

export const createCorrectiveAction = async (input: {
  projectId: string
  failureIds: string[]
  title: string
  description: string
  owner: string
  dueDate: string
}): Promise<any> => unwrap(await post(
  `${config.apiHost}/corrective-actions`,
  input,
  'CORRECTIVE_ACTION_CREATE',
))
